import { render } from "./ViewLearning.vue?vue&type=template&id=9124246c&scoped=true"
import script from "./ViewLearning.vue?vue&type=script&lang=js"
export * from "./ViewLearning.vue?vue&type=script&lang=js"

import "./ViewLearning.vue?vue&type=style&index=0&id=9124246c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9124246c"]])

export default __exports__